import { useContext, useEffect } from 'react';
import invariant from '../tiny-invariant';
import RouterContext from './RouterContext';
import { jsx as _jsx } from "react/jsx-runtime";
function PromptImpl({
  history,
  message
}) {
  useEffect(() => {
    // @ts-expect-error PromptProps allows message functions to return boolean, but
    // TransitionPromptHook only allows string | false | void; the history library
    // treats any truthy value the same as a non-empty string
    return history.block(message);
  }, [history, message]);
  return null;
}

/**
 * The public API for prompting the user before navigating away from a screen.
 */
function Prompt({
  message,
  when = true
}) {
  const context = useContext(RouterContext);
  invariant(context, 'You should not use <Prompt> outside a <Router>');
  return when ? /*#__PURE__*/_jsx(PromptImpl, {
    history: context.history,
    message: message
  }) : null;
}
export default Prompt;